import pushRouteClient from 'root/src/client/logic/route/util/pushRouteClient'

export default ({ recordId, routeId }) => pushRouteClient({	routeId, routeParams: { recordId } })
